export default __webpack_public_path__ + "static/media/srisailamVisitFive.0b40a3f4.jpg";